import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { func, bool, string } from 'prop-types'
import FormInput from '../FormInput'

const required = value => value ? undefined : 'Campo obrigatório'
const playLimit = (value) => {
  if (value < 100) {
    return 'Quantidade de plays deve ser maior que 100.'
  } else {
    return undefined
  }
}

const NewAlertForm = ({
  error,
  handleSubmit,
  pristine,
  submitting,
  userEmail
}) => (
  <form onSubmit={handleSubmit}>
    <div className='row'>
      <div className='col-md-6'>
        <div className='form-group'>
          <Field
            type='text'
            name='name'
            component={FormInput}
            label='Nome do alerta:'
            placeholder='Exemplo: Alerta de 1000 plays'
            direction='vertical'
            validate={required}
          />
        </div>
      </div>

      <div className='col-md-6'>
        <div className='form-group'>
          <Field
            type='number'
            name='value'
            component={FormInput}
            label='Quantidade de plays:'
            placeholder='Exemplo: 1000'
            direction='vertical'
            validate={[required, playLimit]}
          />
        </div>
      </div>
    </div>

    <div className='form-group'>
      <Field
        type='text'
        name='recipients'
        component={FormInput}
        label='Destinatários (e-mails separados por vírgula):'
        placeholder='Exemplo: diogo@exemplo.com, rafael@exemplo.com'
        direction='vertical'
        validate={required}
      />
    </div>
    {error && <strong className='text-danger'>{error}</strong>}
    <div className='form-group'>
      <div className='pull-right'>
        <button type='submit' className='btn btn-primary ml10' disabled={submitting}>Adicionar novo alerta</button>
      </div>
    </div>
  </form>
)

NewAlertForm.propTypes = {
  handleSubmit: func,
  pristine: bool,
  submitting: bool,
  error: string,
  userEmail: string
}

export default reduxForm({ form: 'newAlertForm' })(NewAlertForm)



// WEBPACK FOOTER //
// ./src/components/forms/NewAlertForm.js